<template>
  <b-container>
    <b-row>
      <b-col>
        <h2>Permisos</h2>
        <div
          v-for="(
            groupedPermission, groupedPermissionIndex
          ) of groupedPermissions"
          :key="groupedPermissionIndex"
        >
          <div v-for="(by, byIndex) of groupedPermission" :key="byIndex">
            <div>
              Ruled by
              {{ by.object.name || by.object.region || by.object.country }} ({{
                by.type
              }}):
            </div>
            <ul>
              <div
                v-for="(permission, permissionIndex) of by.permissions"
                :key="permissionIndex"
              >
                <li v-if="permission.permission">
                  {{ permission.permission.name }}
                </li>
              </div>
            </ul>
            <button
              style="
                margin-bottom: 50px;
                margin-right: 50px;
                background-color: #1e4380;
                color: white;
              "
              class="btn"
            >
              Actualizar con Plantilla
            </button>
            <button style="margin-bottom: 50px" class="btn btn-primary">
              Eliminar
            </button>
          </div>
        </div>
        <button
          v-if="!shouldAddNew"
          class="btn btn-primary d-block m-auto"
          variant="primary"
          @click="addNew()"
        >
          Agregar Nuevo
        </button>
        <configuration-wizard-access-controls
          v-if="shouldAddNew"
          ref="accessControls"
          :account-role-template="accountRoleTemplateId"
          :should-save-to-store="false"
        />
        <button
          v-if="shouldAddNew"
          class="btn btn-primary"
          variant="primary"
          @click="save()"
        >
          Guardar
        </button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { axiosCall } from "@/utils/axiosCall";
import ConfigurationWizardAccessControls from "./businessCreation/ConfigurationWizardAccessControls";

export default {
  name: "AccountRoleRuledBy",
  components: { ConfigurationWizardAccessControls },
  props: {
    accountRoleId: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {
      permissions: [],
      groupedPermissions: {},
      shouldAddNew: false,
      accountRoleTemplateId: null,
    };
  },
  watch: {
    accountRoleId: async function () {
      console.log("accountRoleId watch");
      await this.getPermissions();
    },
  },
  created: async function () {
    console.log("accountRoleId created");
    await this.getPermissions();
  },
  methods: {
    async save() {
      let data = {
        accountRoleId: this.accountRoleId,
        ruledBy: this.$refs.accessControls.ruleBy,
        ruledByValue: this.$refs.accessControls.selectedOption,
      };
      await axiosCall({
        url: `AccessControls/createAccessControls`,
        method: "post",
        data,
      }).then(async () => {
        this.shouldAddNew = false;
        await this.getPermissions();
      });
    },
    addNew() {
      this.shouldAddNew = true;
    },
    groupBy() {
      this.groupedPermissions = {
        tag: {},
        region: {},
        country: {},
      };
      this.permissions.map((permission) => {
        if (permission.tag) {
          if (
            typeof this.groupedPermissions.tag[permission.tagId] === "undefined"
          ) {
            this.groupedPermissions.tag[permission.tagId] = {
              permissions: [],
              object: permission.tag,
              type: "Tag",
            };
          }
          this.groupedPermissions.tag[permission.tagId].permissions.push(
            permission
          );
        }

        if (permission.region) {
          if (
            typeof this.groupedPermissions.region[permission.regionId] ===
            "undefined"
          ) {
            this.groupedPermissions.region[permission.regionId] = {
              permissions: [],
              object: permission.region,
              type: "Region",
            };
          }
          this.groupedPermissions.region[permission.regionId].permissions.push(
            permission
          );
        }

        if (permission.country) {
          if (
            typeof this.groupedPermissions.country[permission.countryId] ===
            "undefined"
          ) {
            this.groupedPermissions.country[permission.countryId] = {
              permissions: [],
              object: permission.country,
              type: "Country",
            };
          }
          this.groupedPermissions.country[
            permission.countryId
          ].permissions.push(permission);
        }
      });
    },
    getPermissions: async function () {
      if (this.accountRoleId) {
        await axiosCall({
          url: `AccessControls/getPermissions/${this.accountRoleId}`,
          method: "get",
        }).then((response) => {
          this.permissions = response.data.accountRoles;
          this.groupBy();
        });
        await axiosCall({
          url: `AccountRoles/${this.accountRoleId}`,
          method: "get",
        }).then((response) => {
          this.accountRoleTemplateId = response.data.accountRoleTemplateId;
        });
      }
    },
  },
};
</script>
<style lang="sass">
</style>
